import React, { useRef, useState } from 'react';
import { cn } from '../../lib/utils';
import Icon from './Icon';

export default function FileUpload({
  label,
  accept = 'image/*',
  onFileSelect,
  preview,
  className,
}) {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file && onFileSelect) onFileSelect(file);
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file && onFileSelect) onFileSelect(file);
    e.target.value = '';
  };

  return (
    <div className={cn('space-y-2', className)}>
      {label && <label className="block text-sm font-medium text-text-dark/80">{label}</label>}
      <div
        className={cn(
          'relative border-2 border-dashed rounded-xl p-6 text-center transition-colors',
          dragOver ? 'border-btn bg-btn/5' : 'border-slate-300 hover:border-slate-400',
          'cursor-pointer'
        )}
        onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
        onClick={() => inputRef.current?.click()}
      >
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          className="hidden"
          onChange={handleChange}
        />
        {preview ? (
          <img src={preview} alt="پیش‌نمایش" className="max-h-40 mx-auto rounded-lg object-contain" />
        ) : (
          <div className="flex flex-col items-center gap-2 text-slate-500">
            <Icon name="upload" className="h-8 w-8" />
            <span className="text-sm">برای آپلود کلیک یا بکشید</span>
          </div>
        )}
      </div>
    </div>
  );
}